/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AlternativeCredentials } from '../models/alternative-credentials';
import { apiAccountAlternativeCredentialsGet } from '../fn/account/api-account-alternative-credentials-get';
import { ApiAccountAlternativeCredentialsGet$Params } from '../fn/account/api-account-alternative-credentials-get';
import { apiAccountInitRefreshPost } from '../fn/account/api-account-init-refresh-post';
import { ApiAccountInitRefreshPost$Params } from '../fn/account/api-account-init-refresh-post';
import { apiAccountLoginPost } from '../fn/account/api-account-login-post';
import { ApiAccountLoginPost$Params } from '../fn/account/api-account-login-post';
import { apiAccountLogoutPost } from '../fn/account/api-account-logout-post';
import { ApiAccountLogoutPost$Params } from '../fn/account/api-account-logout-post';
import { apiAccountRefreshTokenGet } from '../fn/account/api-account-refresh-token-get';
import { ApiAccountRefreshTokenGet$Params } from '../fn/account/api-account-refresh-token-get';
import { apiAccountReVerifyAccountPost } from '../fn/account/api-account-re-verify-account-post';
import { ApiAccountReVerifyAccountPost$Params } from '../fn/account/api-account-re-verify-account-post';
import { apiAccountUserInfoGet } from '../fn/account/api-account-user-info-get';
import { ApiAccountUserInfoGet$Params } from '../fn/account/api-account-user-info-get';
import { apiAccountVerifyAccountPost } from '../fn/account/api-account-verify-account-post';
import { ApiAccountVerifyAccountPost$Params } from '../fn/account/api-account-verify-account-post';
import { NotificationMessage } from '../models/notification-message';
import { SignInBundleDto } from '../models/sign-in-bundle-dto';
import { TokenExpiryDto } from '../models/token-expiry-dto';
import { UserMetaDataDto } from '../models/user-meta-data-dto';

@Injectable({ providedIn: 'root' })
export class AccountService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiAccountVerifyAccountPost()` */
  static readonly ApiAccountVerifyAccountPostPath = '/api/account/verify-account';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAccountVerifyAccountPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAccountVerifyAccountPost$Response(params?: ApiAccountVerifyAccountPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAccountVerifyAccountPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAccountVerifyAccountPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAccountVerifyAccountPost(params?: ApiAccountVerifyAccountPost$Params, context?: HttpContext): Observable<void> {
    return this.apiAccountVerifyAccountPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAccountReVerifyAccountPost()` */
  static readonly ApiAccountReVerifyAccountPostPath = '/api/account/re-verify-account';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAccountReVerifyAccountPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAccountReVerifyAccountPost$Response(params?: ApiAccountReVerifyAccountPost$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiAccountReVerifyAccountPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAccountReVerifyAccountPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAccountReVerifyAccountPost(params?: ApiAccountReVerifyAccountPost$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiAccountReVerifyAccountPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

  /** Path part for operation `apiAccountLoginPost()` */
  static readonly ApiAccountLoginPostPath = '/api/account/login';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAccountLoginPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAccountLoginPost$Response(params?: ApiAccountLoginPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SignInBundleDto>> {
    return apiAccountLoginPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAccountLoginPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiAccountLoginPost(params?: ApiAccountLoginPost$Params, context?: HttpContext): Observable<SignInBundleDto> {
    return this.apiAccountLoginPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<SignInBundleDto>): SignInBundleDto => r.body)
    );
  }

  /** Path part for operation `apiAccountRefreshTokenGet()` */
  static readonly ApiAccountRefreshTokenGetPath = '/api/account/refresh-token';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAccountRefreshTokenGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAccountRefreshTokenGet$Response(params?: ApiAccountRefreshTokenGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TokenExpiryDto>> {
    return apiAccountRefreshTokenGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAccountRefreshTokenGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAccountRefreshTokenGet(params?: ApiAccountRefreshTokenGet$Params, context?: HttpContext): Observable<TokenExpiryDto> {
    return this.apiAccountRefreshTokenGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<TokenExpiryDto>): TokenExpiryDto => r.body)
    );
  }

  /** Path part for operation `apiAccountLogoutPost()` */
  static readonly ApiAccountLogoutPostPath = '/api/account/logout';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAccountLogoutPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAccountLogoutPost$Response(params?: ApiAccountLogoutPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAccountLogoutPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAccountLogoutPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAccountLogoutPost(params?: ApiAccountLogoutPost$Params, context?: HttpContext): Observable<void> {
    return this.apiAccountLogoutPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiAccountUserInfoGet()` */
  static readonly ApiAccountUserInfoGetPath = '/api/account/user-info';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAccountUserInfoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAccountUserInfoGet$Response(params?: ApiAccountUserInfoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<UserMetaDataDto>> {
    return apiAccountUserInfoGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAccountUserInfoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAccountUserInfoGet(params?: ApiAccountUserInfoGet$Params, context?: HttpContext): Observable<UserMetaDataDto> {
    return this.apiAccountUserInfoGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserMetaDataDto>): UserMetaDataDto => r.body)
    );
  }

  /** Path part for operation `apiAccountAlternativeCredentialsGet()` */
  static readonly ApiAccountAlternativeCredentialsGetPath = '/api/account/alternative-credentials';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAccountAlternativeCredentialsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAccountAlternativeCredentialsGet$Response(params?: ApiAccountAlternativeCredentialsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AlternativeCredentials>> {
    return apiAccountAlternativeCredentialsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAccountAlternativeCredentialsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAccountAlternativeCredentialsGet(params?: ApiAccountAlternativeCredentialsGet$Params, context?: HttpContext): Observable<AlternativeCredentials> {
    return this.apiAccountAlternativeCredentialsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AlternativeCredentials>): AlternativeCredentials => r.body)
    );
  }

  /** Path part for operation `apiAccountInitRefreshPost()` */
  static readonly ApiAccountInitRefreshPostPath = '/api/account/init-refresh';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiAccountInitRefreshPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAccountInitRefreshPost$Response(params?: ApiAccountInitRefreshPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiAccountInitRefreshPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiAccountInitRefreshPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiAccountInitRefreshPost(params?: ApiAccountInitRefreshPost$Params, context?: HttpContext): Observable<void> {
    return this.apiAccountInitRefreshPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
